"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _DayPickerInput = _interopRequireDefault(require("react-day-picker/DayPickerInput"));

var _propTypes = require("prop-types");

var _DatePicker = require("./DatePicker.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var pad = function pad(deg) {
  return ('0' + deg).slice(-2);
};

var formatDate = function formatDate(date) {
  return "".concat(pad(date.getDate()), "/").concat(pad(date.getMonth() + 1), "/").concat(date.getFullYear());
};

var DayPicker = function DayPicker(_ref) {
  var label = _ref.label,
      id = _ref.id,
      error = _ref.error,
      helper = _ref.helper,
      disabled = _ref.disabled,
      dayPickerProps = _ref.dayPickerProps,
      props = _objectWithoutProperties(_ref, ["label", "id", "error", "helper", "disabled", "dayPickerProps"]);

  var hasError = !!error;
  return _react["default"].createElement(_DatePicker.StyleBase, null, !!label && _react["default"].createElement(_DatePicker.LabelStyle, {
    htmlFor: id,
    hasError: hasError
  }, label), !!helper && _react["default"].createElement(_DatePicker.HelperText, {
    hasError: hasError
  }, helper), _react["default"].createElement(_DatePicker.DayPickerContainer, {
    hasError: hasError,
    disabled: disabled
  }, _react["default"].createElement(_DayPickerInput["default"], _extends({
    formatDate: formatDate,
    placeholder: "DD/MM/YYYY",
    dayPickerProps: dayPickerProps
  }, props)), _react["default"].createElement("svg", {
    width: "18",
    height: "17",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("path", {
    d: "M7.765 3.072h2.47c.432 0 .783-.367.783-.819 0-.452-.35-.82-.783-.82h-2.47c-.432 0-.783.368-.783.82 0 .452.35.82.783.82zm-6.2 12.29h14.87V7.987H1.565v7.373zM18 2.328V16.18c0 .452-.35.819-.783.819H.783C.35 17 0 16.633 0 16.18V2.33c0-.453.35-.895.783-.895h1.829c.432 0 .782.367.782.819 0 .452-.35.82-.782.82H1.565v3.481h14.87V3.072h-1.047c-.432 0-.783-.367-.783-.819 0-.452.35-.82.783-.82h1.83c.432 0 .782.443.782.896zM12.717 4.67c.54 0 .979-.458.979-1.024V1.024C13.696.46 13.258 0 12.717 0c-.54 0-.978.459-.978 1.024v2.623c0 .566.438 1.024.978 1.024zM4.304 3.647V1.024C4.304.46 4.742 0 5.283 0c.54 0 .978.459.978 1.024v2.623c0 .566-.438 1.024-.978 1.024s-.979-.458-.979-1.024z",
    fill: "#000",
    fillRule: "evenodd"
  }))), hasError && _react["default"].createElement(_DatePicker.ErrorText, null, error));
};

DayPicker.propTypes = {
  id: _propTypes.PropTypes.string.isRequired,
  label: _propTypes.PropTypes.string.isRequired,
  helper: _propTypes.PropTypes.string,
  error: _propTypes.PropTypes.string,
  disabled: _propTypes.PropTypes.bool,
  dayPickerProps: _propTypes.PropTypes.object
};
var _default = DayPicker;
exports["default"] = _default;